import * as React from "react";
import * as ReactDOM from "react-dom";
import { FC, useState } from "react";
import { Control } from "ol/control";
import osmImage from "../img/basemaps/osm.png";
import ortoImage from "../img/basemaps/orto2.png";

enum Basemaps {
    Osm = "osm",
    Orto = "orto"
}

export const Basemap: FC<{ this: Control; title: string }> = (props) => {
    const [mapNr, setMapNr] = useState<Basemaps>(Basemaps.Orto);

    const onClick = () => {
        setMapNr(mapNr === Basemaps.Osm ? Basemaps.Orto : Basemaps.Osm);

        const allLayers = props.this.getMap().getLayers().array_;
        allLayers[0].setVisible(mapNr === Basemaps.Osm);
        allLayers[1].setVisible(mapNr === Basemaps.Orto);
    };
    return (
        <button onClick={onClick} title={props.title}>
            <img src={mapNr === Basemaps.Osm ? osmImage : ortoImage} />
        </button>
    );
};

export class BasemapButton extends Control {
    constructor(title: string) {
        const element = document.createElement("div");
        element.id = "basemap-toggle";
        element.className = "mammadaba-map-button ol-unselectable ol-control";
        super({
            element
        });
        ReactDOM.render(<Basemap this={this} title={title} />, element);
    }
}
